import { TMChangeOrderLineResponse, TMChangeOrderResponse } from '@business/entities/tm';
import { ChangeOrderFormData, ChangeOrderLineItemData } from '@modules/timeMaterials/AddEditTMChangeOrderPage/TMChangeOrderForm';

// for calculations
export function getSubTotal(item: ChangeOrderLineItemData) {
  const laborPrice = item.quantity * item.laborPrice || 0;
  const materialPrice = item.quantity * item.materialPrice || 0;
  return laborPrice + materialPrice;
  // return item.quantity * item.unitPrice;
}

export function getItemMarkup(item: ChangeOrderLineItemData) {
  return getSubTotal(item) * (item.markupFactor / 100);
}

export function getItemDependantFactor(item: ChangeOrderLineItemData) {
  return getSubTotal(item) * (item.dependantFactor / 100);
}

export function getItemTotal(item: ChangeOrderLineItemData) {
  return getSubTotal(item) + getItemMarkup(item) + getItemDependantFactor(item);
}

export function getChangeOrderSubTotal(item: ChangeOrderFormData) {
  return item.lineItems.reduce((acc, line) => acc + getSubTotal(line), 0);
}

export function getChangeOrderTotal(item: ChangeOrderFormData) {
  return item.lineItems.reduce((acc, line) => acc + getItemTotal(line), 0);
}
// end form calculations

// BACKEND RESPONSE CALCULATIONS
export function getSubTotalR(item: TMChangeOrderLineResponse) {
  const laborPrice = item.quantity * item.laborPrice || 0;
  const materialPrice = item.quantity * item.materialPrice || 0;
  return laborPrice + materialPrice;
  // return item.quantity * item.unitPrice;
}

export function getItemMarkupR(item: TMChangeOrderLineResponse) {
  return getSubTotalR(item) * (item.markupFactor / 100);
}

export function getItemTotalR(item: TMChangeOrderLineResponse) {
  return getSubTotalR(item) + getItemMarkupR(item);
}

export function getChangeOrderSubTotalR(item: TMChangeOrderResponse) {
  return item.items.reduce((acc, line) => acc + getSubTotalR(line), 0);
}

export function getChangeOrderTotalR(item: TMChangeOrderResponse) {
  return item.items.reduce((acc, line) => acc + getItemTotalR(line), 0);
}

// END BACKEND RESPONSE CALCULATIONS
